import React, { useState, useMemo, useCallback } from "react";
import { TableWrapper, ActionButtonMain } from "./styles/TableStyles";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import ActionItems from "./ActionItems";
import TablePaginations from "./TablePaginations";
import { formatDateTime } from "../../../helpers/DateFormate";

const TableMain = ({
  TableHeadData = [],
  BodyData = [],
  Hasaction = true,
  TableType = "",
  Last_page = false,
  total_pages = "",
  CurrentPage = 1,
  setCurrentPage = () => {},
}) => {
  const [modifiedBodyData, setModifiedBodyData] = useState(BodyData);
  const [SelectedRowData, setSelectedRowData] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: key, direction: direction });
  };

  const sortedData = useMemo(() => {
    const sortedArray = [...modifiedBodyData];

    sortedArray.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
    });

    return sortedArray;
  }, [modifiedBodyData, sortConfig]);

  // ===== this is for the action buttons

  const [anchorEl, setAnchorEl] = useState(null);

  // const ActionhandleClick = (event, row) => {
  //   setSelectedRowData(row);
  //   setAnchorEl(event.currentTarget);
  // };

  const ActionhandleClick = useCallback((event, row) => {
    setSelectedRowData(row);
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // this is for the   paginations

  // const rowsPerPage = 10;
  // const [currentPage, setCurrentPage] = useState(1);

  // const startIndex = (CurrentPage - 1) * rowsPerPage;
  // const endIndex = startIndex + rowsPerPage;
  const pagedData = sortedData;

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  return (
    <TableWrapper className="TableWrapper">
      <TableContainer className="TableContainer">
        <Table>
          <TableHead>
            <TableRow className="table_head">
              {TableHeadData?.map((value, index) => (
                <TableCell
                  key={value.title}
                  colSpan={
                    index === TableHeadData.length - 1 && Hasaction == true
                      ? 2
                      : 1
                  }
                >
                  <TableSortLabel
                    active={sortConfig.key === value.val}
                    direction={sortConfig.direction}
                    onClick={() => handleSort(value.val)}
                    IconComponent={ArrowDropUpIcon}
                  >
                    {value.title}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="table_body">
            {pagedData?.map((row, index) => {
              return (
                <>
                  <TableRow key={index} className={`table__row `}>
                    {Object?.entries(row)?.map(([key, value], cellIndex) => {
                      return (
                        <>
                          <TableCell
                            key={cellIndex + cellIndex}
                            className={`${key}`}
                          >
                            {(() => {
                              if (key === "status") {
                                return (
                                  <span
                                    className={`statusSpan status_${value?.toLowerCase()}`}
                                  >
                                    {value || "N/A"}
                                  </span>
                                );
                              }
                              if (key === "Price") {
                                return value !== null ? "$" + value : "N/A";
                              }
                              if (
                                key === "DriverPrice" ||
                                key === "Amount" ||
                                key === "Commission"
                              ) {
                                return value !== null ? "$" + value : "N/A";
                              }

                              if (key === "PickupLocation") {
                                return null;
                              }

                              if (key === "created_at") {
                                if (
                                  TableType === "drivers/booking" ||
                                  TableType === "dispatches" ||
                                  TableType === "dispatches/myquotes" ||
                                  TableType === "job/complete" ||
                                  TableType === "accounting"
                                ) {
                                  return formatDateTime(
                                    value,
                                    "DD-MM-YYYY hh:mm A"
                                  );
                                } else {
                                  return formatDateTime(value, "DD-MM-YYYY ");
                                }
                              }

                              return value || "N/A";
                            })()}
                          </TableCell>
                        </>
                      );
                    })}

                    {Hasaction && (
                      <TableCell style={{ paddingLeft: "0px" }}>
                        {/* <ActionButtonMain onClick={() => console.log(row)}> */}
                        <ActionButtonMain
                          onClick={(e) => ActionhandleClick(e, row)}
                        >
                          <MoreHorizIcon />
                        </ActionButtonMain>
                        <ActionItems
                          id={id}
                          open={open}
                          handleClose={handleClose}
                          anchorEl={anchorEl}
                          SelectedRow={SelectedRowData}
                          TableType={TableType}
                          modifiedBodyData={modifiedBodyData}
                          setModifiedBodyData={setModifiedBodyData}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {total_pages > 1 && (
        <TablePaginations
          currentPage={CurrentPage}
          totalPages={total_pages}
          // sortedData={sortedData}
          handleChangePage={handleChangePage}
        />
      )}
    </TableWrapper>
  );
};

export default TableMain;
